// @flow

import * as React from 'react';
import type { ComponentType, Element, Node } from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import AdsumCarousel from '@adactive/arc-carousel';
import AceEditor from 'react-ace';

import ACA from './services/ClientAPI';
import { Header } from './components/Header';
import ScreenSaver, { screenSaverActions, ModalWrapper } from './components/ScreenSaver';
import ExampleRouteWrapper from './routeComponents/ExampleRouteWrapper';

import type { ScreenSaverReducersStateType } from './components/ScreenSaver';

import 'brace/mode/jsx';
import 'brace/theme/monokai';

import './App.css';

type AppStateType = {
    screenSaver: ScreenSaverReducersStateType
};

type MappedStatePropsType = {|
|};

type MappedDispatchPropsType = {|
    isHere: () => void
|};

type OwnPropsType = {|
|};

type PropsType = MappedStatePropsType & MappedDispatchPropsType & OwnPropsType;

type ModalPropsType = {|
    modalTimer: number,
    closeModal: () => void,
    isHere: () => void
|};

const ModalComponent = ({ modalTimer, closeModal, isHere }: ModalPropsType): Node => {
    const modalStyles = {
        backgroundColor: 'white',
        width: '500px',
        borderRadius: '10px',
        border: '1px solid grey'
    };
    const modalHeaderStyles = {
        height: '50px',
        backgroundColor: '#0f8a90',
        position: 'relative',
        borderRadius: '10px 10px 0 0'
    };
    const closeButtonStyles = {
        backgroundColor: 'white',
        width: '30px',
        height: '30px',
        position: 'absolute',
        top: '50%',
        right: '20px',
        transform: 'translate(0, -50%)'
    };
    const crossStyles = {
        width: '38px',
        border: '2px solid grey',
        position: 'absolute',
        top: '50%'
    };
    const crossStylesLeft = {
        ...crossStyles,
        transform: 'translate(-6px, -50%) rotate(45deg)'
    };
    const crossStylesRight = {
        ...crossStyles,
        transform: 'translate(-6px, -50%) rotate(-45deg)'
    };
    const modalCounterStyles = {

    };
    const modalCounterHeaderStyles = {
        fontSize: '30px'
    };
    const modalCounterNumbersStyles = {
        margin: '0 auto',
        borderRadius: '50%',
        fontSize: '40px',
        border: '1px solid black',
        width: '100px',
        height: '100px',
        lineHeight: '100px'
    };
    const modalFooterStyles = {};
    const isHereStyles = {
        margin: '35px 0',
        color: '#fff',
        backgroundColor: '#28a745',
        borderColor: '#28a745',
        border: '1px solid transparent',
        padding: '.375rem .75rem',
        lineHeight: '1.5',
        fontSize: '2rem',
        borderRadius: '.25rem',
    };

    return (
        <div className="modal" style={modalStyles}>
            <header className="modalHeader" style={modalHeaderStyles}>
                <div className="closeButton" onClick={closeModal} style={closeButtonStyles}>
                    <div className="cross left" style={crossStylesLeft} />
                    <div className="cross right" style={crossStylesRight} />
                </div>
            </header>
            <div className="modalCounter" style={modalCounterStyles}>
                <h2 className="modalCounterHeader" style={modalCounterHeaderStyles}>Time left</h2>
                <p className="modalCounterNumbers" style={modalCounterNumbersStyles}>{modalTimer}</p>
            </div>
            <footer className="modalFooter" style={modalFooterStyles}>
                <button className="isHere" onClick={isHere} style={isHereStyles}>I am here!</button>
            </footer>
        </div>
    );
};

const WrapperModal = ModalWrapper(ModalComponent);

class App extends React.Component<PropsType> {
    render(): Node {
        return (
            <div className="App">
                <Header logo="http://adactivesas.github.io/adsum-react-components/logo.jpg" />

                <div>
                    <h1>Example with image</h1>
                    <div className="code">
                        <AceEditor
                            height="200px"
                            width="900px"
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`
const WrapperModal = ModalWrapper(ModalComponent);

<ScreenSaver
    modalComponent={<WrapperModal />}
>
    <img src="http://via.placeholder.com/1280x700" />
</ScreenSaver>`}
                        />
                    </div>

                    <h1>Modal component</h1>
                    <div className="code">
                        <AceEditor
                            height="500px"
                            width="900px"
                            mode="jsx"
                            theme="monokai"
                            name="UNIQUE_ID_OF_DIV"
                            editorProps={{ $blockScrolling: true }}
                            fontSize={14}
                            value={`const ModalComponent = ({ modalTimer, closeModal, isHere }: ModalPropsType): Node => {
    const modalStyles = {
        backgroundColor: 'white',
        width: '500px',
        borderRadius: '10px',
        border: '1px solid grey'
    };
    const modalHeaderStyles = {
        height: '50px',
        backgroundColor: '#0f8a90',
        position: 'relative',
        borderRadius: '10px 10px 0 0'
    };
    const closeButtonStyles = {
        backgroundColor: 'white',
        width: '30px',
        height: '30px',
        position: 'absolute',
        top: '50%',
        right: '20px',
        transform: 'translate(0, -50%)'
    };
    const crossStyles = {
        width: '38px',
        border: '2px solid grey',
        position: 'absolute',
        top: '50%'
    };
    const crossStylesLeft = {
        ...crossStyles,
        transform: 'translate(-6px, -50%) rotate(45deg)'
    };
    const crossStylesRight = {
        ...crossStyles,
        transform: 'translate(-6px, -50%) rotate(-45deg)'
    };
    const modalCounterStyles = {
    };
    const modalCounterHeaderStyles = {
        fontSize: '30px'
    };
    const modalCounterNumbersStyles = {
        margin: '0 auto',
        borderRadius: '50%',
        fontSize: '40px',
        border: '1px solid black',
        width: '100px',
        height: '100px',
        lineHeight: '100px'
    };
    const modalFooterStyles = {};
    const isHereStyles = {
        margin: '35px 0',
        color: '#fff',
        backgroundColor: '#28a745',
        borderColor: '#28a745',
        border: '1px solid transparent',
        padding: '.375rem .75rem',
        lineHeight: '1.5',
        fontSize: '2rem',
        borderRadius: '.25rem'
    };
    return (
        <div className="modal" style={modalStyles}>
            <header className="modalHeader" style={modalHeaderStyles}>
                <div className="closeButton" onClick={closeModal} style={closeButtonStyles}>
                    <div className="cross left" style={crossStylesLeft} />
                    <div className="cross right" style={crossStylesRight} />
                </div>
            </header>
            <div className="modalCounter" style={modalCounterStyles}>
                <h2 className="modalCounterHeader" style={modalCounterHeaderStyles}>Time left</h2>
                <p className="modalCounterNumbers" style={modalCounterNumbersStyles}>{modalTimer}</p>
            </div>
            <footer className="modalFooter" style={modalFooterStyles}>
                <button className="isHere" onClick={isHere} style={isHereStyles}>I am here!</button>
            </footer>
        </div>
    );
};`}
                        />
                    </div>

                    <ScreenSaver
                        modalComponent={<WrapperModal />}
                    >
                        <img src="http://via.placeholder.com/1280x700" />
                    </ScreenSaver>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state: AppStateType): MappedStatePropsType => ({

});

const mapDispatchToProps = (dispatch: *): MappedDispatchPropsType => ({
    isHere: (): void => dispatch(screenSaverActions.isHere()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js